import { computed, Ref, ref } from 'vue';
import {
    Certificate,
    LightingSpecification,
    OutletProductDetailsModel,
    ProductDetailCoverMaterial,
} from '@/types/productServerApi';
import useProductSpecificationsData from '@/shared/product/details/ui/product-specifications/useProductSpecificationsData';
import { CollageTileLayoutData } from '@/shared/content/blocks/collage-layouts/collage-layout.store';
import gtmService from '@/shared/tracking/gtm.service';

const data: Ref<OutletProductDetailsModel> = ref({} as OutletProductDetailsModel);

const environmentalImages: Ref<CollageTileLayoutData[]> = ref([] as CollageTileLayoutData[]);

export default function useOutletProductDetailData() {
    const setOutletProductData = (value: OutletProductDetailsModel) => {
        data.value = value;
        setSpecificationData(data.value.originalSku, data.value.originalSku, data.value.specifications, data.value.coverMaterial, undefined);
        gtmService.viewOutletItem(data.value);
    };

    const clearOutletProductData = () => {
        data.value = {} as OutletProductDetailsModel;
        setSpecificationData('', '', undefined, undefined, undefined);
    };

    const originalSku = computed<string>(() => data.value?.originalSku ?? '');

    const { setSpecificationData } = useProductSpecificationsData();
    const outletProductData = computed<OutletProductDetailsModel>(() => data.value ?? {} as OutletProductDetailsModel);

    const lightingSpecification = computed<LightingSpecification | null>(() => data.value.lightingSpecification ?? null);
    const productCertificationPrimary = computed<Certificate | undefined>(() => {
        return data.value?.specifications?.certificates?.find((certification) => certification && certification.imageUrl);
    });

    const coverMaterial = computed<ProductDetailCoverMaterial | undefined>(() => data.value?.coverMaterial);
    const productAddOnCount = computed<number>(() => data.value?.productAddOnCount);

    const setEnvironmentImages = (tiles:CollageTileLayoutData[]) => {
        environmentalImages.value = tiles;
    };

    return {
        setOutletProductData,
        clearOutletProductData,
        setEnvironmentImages,
        outletProductData,
        environmentalImages,
        lightingSpecification,
        productCertificationPrimary,
        coverMaterial,
        productAddOnCount,
        originalSku,
    };
}
